// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgChargingStationIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M19 16v-6c0-4.41-3.59-8-8-8s-8 3.59-8 8v4c0 4.41 3.59 8 8 8 .55 0 1-.45 1-1v-3.14c1.72-.45 3-2 3-3.86v-4c0-2.21-1.79-4-4-4s-4 1.79-4 4v4c0 1.86 1.28 3.41 3 3.86v2.06c-2.83-.48-5-2.95-5-5.92v-4c0-3.31 2.69-6 6-6s6 2.69 6 6v6c-1.1 0-2 .9-2 2v2h1v1.5c0 .28.22.5.5.5s.5-.22.5-.5V20h2v1.5c0 .28.22.5.5.5s.5-.22.5-.5V20h1v-2c0-1.1-.9-2-2-2m-9.22-.05a.496.496 0 0 1-.26-.59l.82-2.86H9.5c-.19 0-.36-.1-.44-.27a.51.51 0 0 1 .04-.52l2.5-3.5c.14-.2.41-.27.62-.16.22.11.33.35.26.59l-.82 2.86h.84c.19 0 .36.1.44.27s.07.37-.04.52l-2.5 3.5c-.1.14-.25.21-.41.21-.07 0-.15-.02-.22-.05z" />
  </g>
);
export default SvgChargingStationIcon;
SvgChargingStationIcon.displayName = 'SvgChargingStationIcon';
